import React, { Suspense } from 'react';

import { Stories as StoriesView } from '@modules/Stories/views/Stories';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


export const Stories: React.FC = () => {

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <StoriesView/>
      </Suspense>
    </ErrorBoundary>
  );
};
